import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';

import { USERS_INITIATE_RESET_PASSWORD, RESET_PASSWORD_CONFIRMATION_SHOW } from './types';

export const initiateResetPassword = (data) =>
    createAction(
        USERS_INITIATE_RESET_PASSWORD,
        createRequestPayload('international', '/login-service/v1/reset-init', 'post', data, { market: 'global' }),
    );

export const showResetPasswordConfirmation = () => createAction(RESET_PASSWORD_CONFIRMATION_SHOW);
